import { render, staticRenderFns } from "./ModalImpressao.vue?vue&type=template&id=5acfec6a&scoped=true&"
import script from "./ModalImpressao.vue?vue&type=script&lang=js&"
export * from "./ModalImpressao.vue?vue&type=script&lang=js&"
import style0 from "./ModalImpressao.vue?vue&type=style&index=0&id=5acfec6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acfec6a",
  null
  
)

export default component.exports